import { generateAbsenceUrlBaseV2 } from "utils/utils";

import type { ApiCallerT } from "shared/infrastructure/api/types";
import type {
  LeaveTypesApiT,
  GetAllLeaveTypesResponseT,
  CreateLeaveTypeResponseT,
  UpdateLeaveTypeResponseT,
  DeleteLeaveTypesResponseT,
} from "../types/leaveTypes.types";
import type {
  CreateJustifiedLeaveTypeRequestDtoT,
  CreateNonJustifiedLeaveTypeRequestDtoT,
  UpdateLeaveTypeRequestDtoT,
  DeleteLeaveTypesRequestDtoT,
  ToggleLeaveTypeActiveStatusRequestDtoT,
} from "../../domain/dtos/leaveType.dto";

export const createLeaveTypesApi = (apiCaller: ApiCallerT): LeaveTypesApiT => ({
  getAll: async (colaboraInstanceId: string, category = "PERMISSION") => {
    const url = generateAbsenceUrlBaseV2(`types?category=${category}`);

    const response = await apiCaller<GetAllLeaveTypesResponseT>(
      url,
      "GET",
      {},
      {},
      { "X-Instance-Id": colaboraInstanceId },
    );

    return response;
  },
  create: async (
    dto:
      | CreateJustifiedLeaveTypeRequestDtoT
      | CreateNonJustifiedLeaveTypeRequestDtoT,
    colaboraInstanceId: string,
  ) => {
    const url = generateAbsenceUrlBaseV2("types?category=PERMISSION");

    const response = await apiCaller<CreateLeaveTypeResponseT>(
      url,
      "POST",
      dto,
      {},
      { "X-Instance-Id": colaboraInstanceId },
    );

    return response;
  },
  update: async (
    dto: UpdateLeaveTypeRequestDtoT,
    colaboraInstanceId: string,
    category: string,
  ) => {
    const url = generateAbsenceUrlBaseV2(`types?category=${category}`);

    const response = await apiCaller<UpdateLeaveTypeResponseT>(
      url,
      "PUT",
      dto,
      {},
      { "X-Instance-Id": colaboraInstanceId },
    );

    return response;
  },
  delete: async (
    dto: DeleteLeaveTypesRequestDtoT,
    colaboraInstanceId: string,
  ) => {
    const url = generateAbsenceUrlBaseV2("types");

    const response = await apiCaller<DeleteLeaveTypesResponseT>(
      url,
      "DELETE",
      dto,
      {},
      { "X-Instance-Id": colaboraInstanceId },
    );

    return response;
  },
  toggleActiveStatus: async (
    typeId: string,
    dto: ToggleLeaveTypeActiveStatusRequestDtoT,
    colaboraInstanceId: string,
  ) => {
    const url = generateAbsenceUrlBaseV2(`types/${typeId}`);

    const response = await apiCaller(
      url,
      "PATCH",
      dto,
      {},
      { "X-Instance-Id": colaboraInstanceId },
    );

    return response;
  },
});
